// extracted by mini-css-extract-plugin
export default {"vendorLogo":"vendorLogo__YTIyY","zolaLogo":"zolaLogo__Njg0Z"};